import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { getORSubscription } from './orSubscription';
import { getOrders } from './orOrders';

const GET_HOLIDAYS_URL = `${config.apiBasePath}/slotsub/holidays`;
const PUT_ON_HOLD_URL = `${config.apiBasePath}/slotsub/subscription/status/ON_HOLD`;
const ACTIVATE_URL = `${config.apiBasePath}/slotsub/subscription/status/ACTIVE`;
const ADD_HOLIDAY_URL = `${config.apiBasePath}/slotsub/holidays`;
const CANCEL_SUBSCRIPTION_URL = `${config.apiBasePath}/slotsub/subscription`;
const CANCEL_HOLIDAY_URL = `${config.apiBasePath}/slotsub/holidays`;
const GET_DAYS_URL = `${config.apiBasePath}/slotsub/days`;

export const OR_CHANGE_SETTINGS_TAB = 'OR_CHANGE_SETTINGS_TAB';

export const OR_REQUEST_HOLIDAYS = 'OR_REQUEST_HOLIDAYS';
export const OR_RECEIVE_HOLIDAYS = 'OR_RECEIVE_HOLIDAYS';
export const OR_RECEIVE_HOLIDAYS_ERROR = 'OR_RECEIVE_HOLIDAYS_ERROR';

export const OR_SHOW_ADD_HOLIDAY_MODAL = 'OR_SHOW_ADD_HOLIDAY_MODAL';
export const OR_HIDE_ADD_HOLIDAY_MODAL = 'OR_HIDE_ADD_HOLIDAY_MODAL';

export const OR_REQUEST_ADD_HOLIDAY = 'OR_REQUEST_ADD_HOLIDAY';
export const OR_ADD_HOLIDAY_SUCCESS = 'OR_ADD_HOLIDAY_SUCCESS';
export const OR_ADD_HOLIDAY_ERROR = 'OR_ADD_HOLIDAY_ERROR';

export const OR_TOGGLE_CANCEL_HOLIDAY_MODAL = 'OR_TOGGLE_CANCEL_HOLIDAY_MODAL';
export const OR_REQUEST_HOLIDAY_CANCEL = 'OR_REQUEST_HOLIDAY_CANCEL';
export const OR_HOLIDAY_CANCEL_SUCCESS = 'OR_HOLIDAY_CANCEL_SUCCESS';
export const OR_HOLIDAY_CANCEL_ERROR = 'OR_HOLIDAY_CANCEL_ERROR';

export const OR_SHOW_PUT_ON_HOLD_MODAL = 'OR_SHOW_PUT_ON_HOLD_MODAL';
export const OR_HIDE_PUT_ON_HOLD_MODAL = 'OR_HIDE_PUT_ON_HOLD_MODAL';

export const OR_REQUEST_PUT_ON_HOLD = 'OR_REQUEST_PUT_ON_HOLD';
export const OR_PUT_ON_HOLD_SUCCESS = 'OR_PUT_ON_HOLD_SUCCESS';
export const OR_PUT_ON_HOLD_ERROR = 'OR_PUT_ON_HOLD_ERROR';

export const OR_REQUEST_ACTIVATION = 'OR_REQUEST_ACTIVATION';
export const OR_ACTIVATION_SUCCESS = 'OR_ACTIVATION_SUCCESS';
export const OR_ACTIVATION_ERROR = 'OR_ACTIVATION_ERROR';

export const OR_SHOW_CANCEL_SUBSCRIPTION_MODAL = 'OR_SHOW_CANCEL_SUBSCRIPTION_MODAL';
export const OR_HIDE_CANCEL_SUBSCRIPTION_MODAL = 'OR_HIDE_CANCEL_SUBSCRIPTION_MODAL';
export const OR_REQUEST_CANCEL_SUBSCRIPTION = 'OR_REQUEST_CANCEL_SUBSCRIPTION';
export const OR_SUBSCRIPTION_CANCELLATION_SUCCESS = 'OR_SUBSCRIPTION_CANCELLATION_SUCCESS';
export const OR_SUBSCRIPTION_CANCELLATION_ERROR = 'OR_SUBSCRIPTION_CANCELLATION_ERROR';

export const OR_REQUEST_DAYS = 'OR_REQUEST_DAYS';
export const OR_RECEIVE_DAYS = 'OR_RECEIVE_DAYS';
export const OR_RECEIVE_DAYS_ERROR = 'OR_RECEIVE_DAYS_ERROR';

export function changeSettingsTab(activeTab) {
  return {
    type: OR_CHANGE_SETTINGS_TAB,
    activeTab,
  };
}

export function requestHolidays() {
  return {
    type: OR_REQUEST_HOLIDAYS,
  };
}

export function receiveHolidays(data) {
  return {
    type: OR_RECEIVE_HOLIDAYS,
    data,
  };
}

export function receiveHolidaysError({ error }) {
  return {
    type: OR_RECEIVE_HOLIDAYS_ERROR,
    error,
  };
}

export function getHolidays() {
  return (dispatch, getState, { network }) => {
    dispatch(requestHolidays());
    return network.get(GET_HOLIDAYS_URL)
      .then((data) => {
        dispatch(receiveHolidays(data));
      })
      .catch(err => {
        dispatch(receiveHolidaysError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function showAddHolidayModal() {
  return {
    type: OR_SHOW_ADD_HOLIDAY_MODAL,
  };
}

export function hideAddHolidayModal() {
  return {
    type: OR_HIDE_ADD_HOLIDAY_MODAL,
  };
}

export function requestAddHoliday() {
  return {
    type: OR_REQUEST_ADD_HOLIDAY,
  };
}

export function addHolidaySuccess(data) {
  return {
    type: OR_ADD_HOLIDAY_SUCCESS,
    data,
  };
}

export function addHolidayError({ error }) {
  return {
    type: OR_ADD_HOLIDAY_ERROR,
    error,
  };
}

export function addHoliday({ startDate, endDate }) {
  return (dispatch, getState, { network }) => {
    dispatch(requestAddHoliday());
    return network.post(ADD_HOLIDAY_URL, {
      body: JSON.stringify({ startDate, endDate }),
    })
      .then((data) => {
        dispatch(addHolidaySuccess(data));
        dispatch(getHolidays());
        dispatch(getOrders());
      })
      .catch(err => {
        dispatch(addHolidayError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function toggleCancelHolidayModal(id) {
  return {
    type: OR_TOGGLE_CANCEL_HOLIDAY_MODAL,
    id,
  };
}

export function requestHolidayCancel() {
  return {
    type: OR_REQUEST_HOLIDAY_CANCEL,
  };
}

export function holidayCancelSuccess() {
  return {
    type: OR_HOLIDAY_CANCEL_SUCCESS,
  };
}

export function holidayCancelError({ error }) {
  return {
    type: OR_HOLIDAY_CANCEL_ERROR,
    error,
  };
}

export function cancelHoliday(id) {
  return (dispatch, getState, { network }) => {
    dispatch(requestHolidayCancel());
    return network.del(`${CANCEL_HOLIDAY_URL}/${id}`)
      .then(() => {
        dispatch(holidayCancelSuccess());
        dispatch(getHolidays());
        dispatch(getOrders());
      })
      .catch(err => {
        dispatch(holidayCancelError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function showPutOnHoldModal() {
  return {
    type: OR_SHOW_PUT_ON_HOLD_MODAL,
  };
}

export function hidePutOnHoldModal() {
  return {
    type: OR_HIDE_PUT_ON_HOLD_MODAL,
  };
}

export function requestPutOnHold() {
  return {
    type: OR_REQUEST_PUT_ON_HOLD,
  };
}

export function putOnHoldSuccess(data) {
  return {
    type: OR_PUT_ON_HOLD_SUCCESS,
    data,
  };
}

export function putOnHoldError({ error }) {
  return {
    type: OR_PUT_ON_HOLD_ERROR,
    error,
  };
}

export function putOnHold() {
  return (dispatch, getState, { network }) => {
    dispatch(requestPutOnHold());
    return network.put(PUT_ON_HOLD_URL)
      .then((data) => {
        dispatch(putOnHoldSuccess(data));
        dispatch(getORSubscription());
        dispatch(getOrders());
      })
      .catch(err => {
        dispatch(putOnHoldError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function requestActivation() {
  return {
    type: OR_REQUEST_ACTIVATION,
  };
}

export function activationSuccess(data) {
  return {
    type: OR_ACTIVATION_SUCCESS,
    data,
  };
}

export function activationError({ error }) {
  return {
    type: OR_ACTIVATION_ERROR,
    error,
  };
}

export function activateSubscription() {
  return (dispatch, getState, { network }) => {
    dispatch(requestActivation());
    return network.put(ACTIVATE_URL)
      .then((data) => {
        dispatch(activationSuccess(data));
        dispatch(getORSubscription());
        dispatch(getOrders());
      })
      .catch(err => {
        dispatch(activationError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function showCancelSubscriptionModal() {
  return {
    type: OR_SHOW_CANCEL_SUBSCRIPTION_MODAL,
  };
}

export function hideCancelSubscriptionModal() {
  return {
    type: OR_HIDE_CANCEL_SUBSCRIPTION_MODAL,
  };
}

export function requestCancelSubscription() {
  return {
    type: OR_REQUEST_CANCEL_SUBSCRIPTION,
  };
}

export function subscriptionCancellationSuccess() {
  return {
    type: OR_SUBSCRIPTION_CANCELLATION_SUCCESS,
  };
}

export function subscriptionCancellationError({ error }) {
  return {
    type: OR_SUBSCRIPTION_CANCELLATION_ERROR,
    error,
  };
}

export function cancelSubscription() {
  return (dispatch, getState, { network }) => {
    dispatch(requestCancelSubscription());
    return network.del(CANCEL_SUBSCRIPTION_URL)
      .then(() => {
        dispatch(subscriptionCancellationSuccess());
        network.redirectTo({ to: '/or-signup' });
      })
      .catch(err => {
        dispatch(subscriptionCancellationError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function requestDays() {
  return {
    type: OR_REQUEST_DAYS,
  };
}

export function receiveDays(data) {
  return {
    type: OR_RECEIVE_DAYS,
    data,
  };
}

export function receiveDaysError({ error }) {
  return {
    type: OR_RECEIVE_DAYS_ERROR,
    error,
  };
}

export function getDays() {
  return (dispatch, getState, { network }) => {
    dispatch(requestDays());
    return network.get(GET_DAYS_URL)
      .then((data) => {
        dispatch(receiveDays(data));
      })
      .catch(err => {
        dispatch(receiveDaysError(err.data || UNKNOWN_ERROR));
      });
  };
}
